<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'staffRequirement', params: {} }">
            Staff Requirement
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'staffRequirementView', params: {} }">
              View Staff Requirement
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Staff Requirement
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="staffRequirement.staff">
            <td max-width="35%" class="text-subtitle-1">Staff:</td>
            <td>
              {{ getRelationText(staffRequirement.staff, "staff", "firstName") }}
            </td>
          </tr>
          
          <tr v-if="staffRequirement.requirement">
            <td max-width="35%" class="text-subtitle-1">Requirement:</td>
            <td>
              {{ getRelationText(staffRequirement.requirement, "requirement", "name") }}
            </td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getStaffRequirement } from "@/services/staffRequirement";
    
              import { getAllStaff } from "@/services/staff";
            
              import { getAllRequirements } from "@/services/requirement";
            

    export default {
      data() {
        return {
            id: '',
            staffRequirement: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "staffRequirementEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getStaffRequirement(this.id)
            .then((response) => {
              this.staffRequirement = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading staffRequirement");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          
            const params_staff = {
              page: 0,
              size: 100
            };
            await getAllStaff(params_staff)
              .then(response => {
                this.relations.staff = response.data.content;
                return this.relations.staff;
              });
            
            const params_requirement = {
              page: 0,
              size: 100
            };
            await getAllRequirements(params_requirement)
              .then(response => {
                this.relations.requirement = response.data.content;
                return this.relations.requirement;
              });
            
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    